import { ImageSwiper } from 'app/design/primitives/image-swiper';
import type { PlaceDetails } from './shared';

export function PlaceCover({ placeDetails }: { placeDetails?: PlaceDetails | null }) {
  if (!placeDetails?.coverPictures) return null;
  const images = Object.values(placeDetails.coverPictures as Record<string, string | undefined>)
    .map((url, index) => (url ? { id: `place-details-cover-picture-${String(index + 1)}`, url } : null))
    .filter((image): image is { id: string; url: string } => image !== null);
  return <ImageSwiper images={images} backgroundColor="text.brand" height={200} />;
}
